import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'

import {createUser, listUsers, updateUser} from './api'
import {userKeys} from './query-keys'
import type {CreateUserInput, UpdateUserInput} from './schemas'

export function useUsers(options?: {enabled?: boolean}) {
    return useQuery({
        queryKey: userKeys.list(),
        queryFn: listUsers,
        enabled: options?.enabled ?? true,
    })
}

export function useCreateUser() {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (input: CreateUserInput) => createUser(input),
        onSuccess: () => {
            void queryClient.invalidateQueries({queryKey: userKeys.all})
        },
    })
}

export function useUpdateUser() {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: ({userId, input}: {userId: string; input: UpdateUserInput}) =>
            updateUser(userId, input),
        onSuccess: () => {
            void queryClient.invalidateQueries({queryKey: userKeys.all})
        },
    })
}
